// non-slip-flooring products (1 items)
export const productsNonSlip = [
  {
    id: 15,
    slug: "safestep-plus",
    name: "SafeStep Plus",
    variant: "Non-Slip Flooring",
    type: "Non-Slip Flooring",
    category: "Non-Slip Flooring",

    categoryId: "non-slip-flooring",    productSheetPdf: "/Assets/pdf/safestep-plus/PS_ISS_SafeStepPlus.pdf",
    techSpecsPdf: "/Assets/pdf/safestep-plus/PS_TechSpecs_SafeStepPlus.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 5,
    sizeFormat: "Rolls",
    zones: [3],
      industries: ["Grocery & Convenience Stores", "Hospitality Sector", "Specialty Stores"],
      colorTones: ["charcoal", "grey", "brown", "red"],
      patterns: ["solid", "textured"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/SafeStep-Plus/safestep_thumbnail.jpg",
    heroImage: "/Assets/images/products/SafeStep-Plus/safestep_hero-img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "PVC",
      construction: "Post-Industrial Recycled Homogeneous PVC",
      backing: "PVC",
      thickness: "0.25 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Glue-down",
      recommendedZone: "Zone 3",
      bestUseCase: "kitchen, restraurants"
    },
    keyFeatures: [
      "Slip-resistant, stain-resistant, and non-absorbent",
      "Resistant to mildew and bacterial growth",
      "Made from 90% post-industrial recycled materials"
    ],
    gallery: [
      "/Assets/images/products/SafeStep-Plus/safestep_dishwash_grey.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_giant_eagle_bakery.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_giant_deli_counter.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_kitchen.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_install_argyle.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_bar.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_darkgrey.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_kitchen_d.jpg",
      "/Assets/images/products/SafeStep-Plus/safestep_kitchen3.jpg"
    ],
    swatches: [
      { name: "Charcoal", image: "/Assets/images/products/SafeStep-Plus/safestep_charcoal.png" },
      { name: "Mesa", image: "/Assets/images/products/SafeStep-Plus/safestep_mesa.png" },
      { name: "Mocha", image: "/Assets/images/products/SafeStep-Plus/safestep_mocha.png" },
      { name: "Pewter", image: "/Assets/images/products/SafeStep-Plus/safestep_pewter.png" },
      { name: "Slate", image: "/Assets/images/products/SafeStep-Plus/safestep_slate.png" }
    ],
    isPlaceholder: false,
    description: "SafeStep Plus is engineered for comfort, safety, and performance in wet, high-traffic environments like commercial kitchens and bars. Slip-resistant, stain-resistant, and non-absorbent, this non-slip flooring stands up to water, grease, animal fats, and harsh cleaning chemicals. Made from 100% pre-consumer recycled content, SafeStep Plus offers advanced protection against slips, stains, and fire, making it the reliable choice for facilities that demand durability under extreme conditions.",
    features: [
      "Resistant to mildew and bacterial growth",
      "Reinforced with short staple PET fiber",
      "Manufactured from 90% post-industrial recycled materials"
    ],
    specifications: {
      type: "A better-performing alternative to traditional kitchen tiles",
      comfort: "Flexible, anti-fatigue surface reduces strain on standing employees",
      certification: "Certified by the National Floor Safety Institute"
    }
  },
];
